import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type BadgeTone = "neutral" | "success" | "danger" | "accent";
type LegacyVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "success"
  | "warning";

const toneClass: Record<BadgeTone, string> = {
  neutral: "bg-slate-100 text-slate-700",
  success: "bg-emerald-100 text-emerald-700",
  danger: "bg-red-100 text-red-700",
  accent: "bg-blue-100 text-blue-700",
};

export function BadgeV2({
  tone = "neutral",
  variant,
  className,
  children,
}: {
  tone?: BadgeTone;
  variant?: LegacyVariant;
  className?: string;
  children: ReactNode;
}) {
  const resolvedTone =
    tone !== "neutral"
      ? tone
      : variant === "success"
        ? "success"
        : variant === "destructive"
          ? "danger"
          : variant === "default" || variant === "warning"
            ? "accent"
            : "neutral";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
        toneClass[resolvedTone],
        variant === "outline" &&
          "border border-[var(--v2-border)] bg-white text-slate-700",
        variant === "secondary" && "bg-slate-200 text-slate-700",
        className
      )}
    >
      {children}
    </span>
  );
}
